import React, { FC, useContext, useEffect, useMemo, useState } from "react";
import facebookSvg from "images/Facebook.svg";
import twitterSvg from "images/Twitter.svg";
import googleSvg from "images/Google.svg";
import { Helmet } from "react-helmet";
import Input from "shared/Input/Input";
import { Link, useLocation, useNavigate } from "react-router-dom";
import ButtonPrimary from "shared/Button/ButtonPrimary";

import { PhoneInput } from 'react-international-phone';
//import 'react-international-phone/style.css';
import { requestAPI } from "utils/api";
import { UIContext } from "contexts/UIContext";
import { GlobalDataContext } from "contexts/GlobalData";

import SigninForm from "components_custom/SigninForm/SigninForm";


export interface PageLoginProps {
  className?: string;
}



const Signin: FC<PageLoginProps> = ({ className = "" }) => {
	
	const {
		toast,
	} = useContext(UIContext);  
	const { 
		initData
	} = useContext (GlobalDataContext);

	const navigate = useNavigate ();

	//const [phone, setPhone] = useState('');
	//const [countryCallingNumber, setCountryCallingNumber] = useState('');
	const [checkUser, setCheckUser] = useState ("GUEST");
	//const [verificationCode, setVerificationCode] = useState('');

	useEffect(()=>{
		if (initData.token_info.permission_group === "user") navigate('/home');
	},[])

	if (initData.token_info.permission_group === "user") return (<></>);


	return (
		<div className={`nc-PageLogin ${className}`} data-nc-id="PageLogin">
			{/* <Helmet>
				<title>Login || 올타(Allta)</title>
			</Helmet> */}
			<div className="container mb-24 lg:mb-32">
				<h2 className="my-20 flex items-center text-3xl leading-[115%] md:text-5xl md:leading-[115%] font-semibold text-neutral-900 dark:text-neutral-100 justify-center">
					Login
				</h2>
				<div className="max-w-md mx-auto space-y-6">
				
					
					<SigninForm />


				</div>
			</div>
		</div>
  	);
};

export default Signin;
